import { Attributes, Misc, Rules, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../TemporalEntity';

export default class QPTracking extends TemporalEntity {
    static typeName = "QPTracking";

    constructor() {
        super();
        this.makeObservable();
    }

    public qpTrackingId: number = 0;

    @Rules.Required()
    public investorInvestmentId: number | null = null;

    @Attributes.NoTracking(Misc.SerialiseType.FullOnly)
    public investorInvestmentName: string = "";

    @Attributes.Float()
    @Attributes.NoTracking(Misc.SerialiseType.FullOnly)
    public investorInvestmentCurrentBalance: number = 0;

    @Rules.Required()
    public issuerInvestmentId: number | null = null;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date | null = null;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date | null = null;

    @Attributes.Float()
    public amount: number = 0;

    public qpGroupId: number = 0;

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<QPTracking>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.investorInvestmentName) {
            return "New qp tracking";
        } else {
            return this.investorInvestmentName;
        }
    }
}